import { faker } from '@faker-js/faker';

export class Factory<T extends object> {
  protected transforms: Array<(obj: T) => void> = [];

  protected definition(): T {
    return {} as T;
  }

  protected withState(transform: (obj: T) => void): this {
    this.transforms.push(transform);
    return this;
  }

  create(data?: Partial<T>): T {
    const instance = this.definition();

    this.transforms.forEach((transform) => {
      transform(instance);
    });

    return Object.assign(instance, data ?? {});
  }

  createMany(count: number, data?: Partial<T>): T[] {
    return Array.from({ length: count }, () => this.create(data));
  }
}

export function mockTwrn(
  model: string,
  options?: {
    product?: string;
    category?: string;
    location?: string;
  },
) {
  const twrnParts = [
    'twrn',
    options?.category ?? 'fin',
    options?.location ?? 'us',
    options?.product ?? 'gm',
    model,
  ];

  const randomString = Math.random().toString(36).substring(2, 15);
  twrnParts.push(randomString);

  return twrnParts.join(':');
}

export function mockBudgetName() {
  return faker.helpers.arrayElement([
    'Football',
    'Basketball',
    'Baseball',
    'Soccer',
    'Volleyball',
  ]) + ' Budget ' + faker.string.numeric(3);
}

export function mockAcademicYearDateId(year?: number) {
  const currentYear = year ?? new Date().getFullYear();

  return `${currentYear}-${currentYear + 1}`;
}
